import { put, takeLatest } from 'redux-saga/effects';
import {
  createArticleCommentRequest,
  createArticleCommentFail,
  createArticleCommentSuccess,
  getArticleCommentListRequest,
  getArticleCommentListSuccess,
  getArticleCommentListFail,
} from './actions';
import { apiCall } from '../../effects';
import ArticleService from '../../../services/ArticleService';
import { notify } from '../notifications/actions';
import { getErrorNotification } from '../../util';
import { getDefaultArticleCommentsParams } from '../../../views/projects/tab-activity/config';

function* createArticleComment({ payload }: ReturnType<typeof createArticleCommentRequest>) {
  try {
    yield apiCall(ArticleService.createActivityComment, payload);
    yield put(createArticleCommentSuccess());
    yield put(getArticleCommentListRequest(getDefaultArticleCommentsParams(payload.project_id)));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(createArticleCommentFail());
  }
}

function* getArticleCommentList({ payload }: ReturnType<typeof getArticleCommentListRequest>) {
  try {
    const list = yield apiCall(ArticleService.list, payload);
    yield put(getArticleCommentListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getArticleCommentListFail());
  }
}

export default [
  takeLatest(createArticleCommentRequest.type, createArticleComment),
  takeLatest(getArticleCommentListRequest.type, getArticleCommentList),
];
